import { message } from "antd";
import http from "../http";
import axios from "axios";
const sortBlogByPostCount = (blogs) =>
  blogs.sort((a, b) => {
    return b.postCount - a.postCount;
  });
/**
 * @param  {} userId: UserId of the user
 * @param  {} size=10
 * @param  {} page=1
 * @param  {} category='published': Default blog category should be published
 */
const getDefaultBlog = (userId, size = 5, page = 1, category = "published") => {
  return (dispatch) => {
    return uGetBlogs({ size, page, category, searchByUserId: userId })
      .then((res) => {
        const data = res; // sortBlogByPostCount(_data.blogs); // will filter based on highest post count for now.
        // TODO: Remove sorting mechanism later once we get the default blog from the API.
        localStorage.setItem("BlogsUser", JSON.stringify(data?.blogs?.[0]));
        dispatch({
          type: "SET_DEFAULT_BLOG",
          selectedBlog: data?.blogs?.[0] || { id: "" },
        });
        return "success";
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
        return "error";
      });
  };
};
const getBlogs = (
  size = 10,
  page = 1,
  category,
  search,
  searchByBlog,
  searchByAuthor,
  searchByTag,
  searchByUserId = ""
) => {
  console.log(
    "BLOG SEARCH: ",
    category,
    search,
    searchByBlog,
    searchByAuthor,
    searchByTag,
    searchByUserId
  );
  return (dispatch) => {
    return uGetBlogs({
      size,
      page,
      category,
      search,
      searchByBlog,
      searchByAuthor,
      searchByTag,
      searchByUserId,
    })
      .then((res) => {
        const data = res;
        dispatch({
          type: "GET_BLOGS",
          blogs: data.blogs,
          blogCount: data.count,
          blogCurrent: page,
        });
        return "success";
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
        return "error";
      });
  };
};
/**
 * @description: Utility function for getting blog related details.
 */
const uGetBlogs = ({
  size,
  page,
  category,
  search,
  searchByBlog,
  searchByAuthor,
  searchByTag,
  searchByUserId,
}) => {
  const c = category ? `&category=${category}` : "";
  const s = search ? `&search=${search}` : "";
  const sb = searchByBlog ? `&blog=${searchByBlog}` : "";
  const sa = searchByAuthor ? `&author=${searchByAuthor}` : "";
  const st = searchByTag ? `&tag=${searchByTag}` : "";
  const user = searchByUserId ? `&userId=${searchByUserId}` : "";
  return http
    .get(`/blogs?size=${size}&page=${page}` + c + s + sb + sa + st + user)
    .then((res) => {
      return res?.data?.data;
    });
};

const getBlogDetails = (id) => {
  return (dispatch) => {
    http
      .get(`/blogs/` + id)
      .then((res) => {
        const data = res.data.data;
        dispatch({
          type: "GET_BLOG_DETAIL",
          blog: data,
        });
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const postBlogs = (body) => {
  return (dispatch) => {
    return http
      .post(`/blogs`, body)
      .then((res) => {
        dispatch({
          type: "SET_BLOG_STATUS",
          payload: {
            mainBlogId: res.data.data.id,
            hasBlog: true,
            blogData: res.data.data,
          },
        });
        message.success("Blog added Successfully");
        return res;
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const updateBlogs = (id, body) => {
  return (dispatch) => {
    return http
      .put(`/blogs/${id}`, body)
      .then((res) => {
        message.success("Blog updated Successfully");
        dispatch(getBlogDetails(id));
        return res;
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const setBlogPage = (page) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BLOG_PAGE",
      blogPage: page,
    });
  };
};

const followBlog = (id) => {
  return (dispatch) => {
    return http
      .put(`/blogs/${id}/follows`)
      .then((res) => {
        message.success("Blog followed Successfully");
        return res;
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const unfollowBlog = (id) => {
  return (dispatch) => {
    return http
      .delete(`/blogs/${id}/follows`)
      .then((res) => {
        message.success("Blog unfollowed Successfully");
        return res;
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const physFollowers = (userId, size = 10, page = 1, type = "physician") => {
  return (dispatch) => {
    http
      .get(`/users/${userId}/followers?size=${size}&page=${page}&type=${type}`)
      .then((res) => {
        const data = res.data.data;
        dispatch({
          type: "GET_PHYS_FOLLOWERS",
          followers: data.followers,
          followerCount: data.count,
          followerCurrent: page,
        });
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const createBlogModal = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SHOW_CREATE_BLOG",
      show: value,
    });
  };
};

const searchBlogs = (term) => (dispatch) => {
  http
    .get(`/blogs?page=${1}&size=${5}&search=${term}`)
    .then(({ data }) => {
      let search = [];
      data.data.blogs.map((p) => {
        search.push({ imgUrl: p?.author?.profileImage, title: p.title });
      });
      dispatch({
        type: "SET_SUGGESTIONS",
        suggestions: search,
      });
    })
    .catch(({ response }) => {
      dispatch({
        type: "SET_SUGGESTIONS",
        suggestions: [],
      });
    });
};

const searchAuthors = (term) => (dispatch) => {
  http
    .get(`/blogs?page=${1}&size=${5}&author=${term}`)
    .then(({ data }) => {
      let search = [];
      data.data.blogs.map((b) => {
        search.push({
          imgUrl: b?.author?.profileImage,
          title: b?.author?.firstName + " " + b?.author?.lastName,
        });
      });
      dispatch({
        type: "SET_SUGGESTIONS",
        suggestions: search,
      });
    })
    .catch(({ response }) => {
      dispatch({
        type: "SET_SUGGESTIONS",
        suggestions: [],
      });
    });
};

const getAuthorContactInfo = (id) => (dispatch) => {
  axios
    .get(`https://www.dovemed.com/api/v1/physician-profile/physicians/${id}`)
    .then((res) => res?.data?.data)
    .catch((err) => console.log(err));
};

export {
  getBlogs,
  getBlogDetails,
  postBlogs,
  updateBlogs,
  setBlogPage,
  followBlog,
  unfollowBlog,
  physFollowers,
  getDefaultBlog,
  createBlogModal,
  uGetBlogs,
  searchBlogs,
  searchAuthors,
  getAuthorContactInfo,
};
